export default __webpack_public_path__ + "static/play-store-6c90fd602db3a4e55094d9c833551c77.png";